import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import commonUtil from "../../../common/commonUtil";
import CommonValidation from "../../../common/commonValidation";
import { changeReserve, getAgreeInfo, getMemberRelationList, getServiceCheck, getVacancyCalendarRstEsthe, setReserve } from "../../../const";
import MessageConst from '../../../const/messageConst';
import { useRtoaster } from "../../../hooks/useRtoaster";
import common from "../../../resources/js/common/common";
import { Button } from "../../atoms/button";
import { Label } from "../../atoms/label";
import { BreadCrumb } from '../../molecules/breadCrumb';
import { ErrorMassage } from "../../molecules/errorMassage";
import { RestaurantInputList } from "../../molecules/restaurantInputList";
import { MembershipFooterContainer } from '../common/membershipFooterContainer';
import './../../../resources_membership_hotel/css/hotel/inputUser.css';

const RestaurantInputUserContainer = (props) => {
    const {
        login,
        // propertyInfo,
        setPropertyInfo,
        onClickOpenPopupWindow,
        onClickOpenCalendarWindow,
        restaurantInfo,
        restaurantReserveInfo,
        setRestaurantReserveInfo,
        serviceCheckInfo,
        setServiceCheckInfo,
        setPopupData,
        setChangeFlg
    } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const history = useHistory();
    const store = useStore();
    const [linkList, setLinkList] = useState([]);
    const [agreementList, setAgreementList] = useState([]);
    const [relationList, setRelationList] = useState([]);
    const [vacancyItems, setVacancyItems] = useState([]);
    const loginUserInfo = login.loginUserInfo;
    const isCrawl = login.loginType === 'CRAWL';
    const crawlMember = store.getState().crawlMember;
    const userInfoReq = isCrawl && crawlMember ?
        {
            syainNo: crawlMember.syain_no,
            uketukeCd: crawlMember.uketuke_cd,
            uketukeBashoCd: crawlMember.uketukebasyo_cd,
        } : null;
    // プロパティ一覧

    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessage: null, errorFlg: false, });
    const [temporaryErrorInfo, setTemporaryErrorInfo] = useState({ errorMessage: "", errorFlg: false, });
    const [flgList, setFlgList] = useState({});
    const [illegalFlg, setIllegalFlg] = useState(false);

    // rtoasterタグ生成
    const customParam = {
        "sisetucd": restaurantInfo.shisetsuCd,
        "restaurantcd": restaurantInfo.restaurantCd,
        "keiyakuno": restaurantInfo.keiyakuNo,
    }
    useRtoaster(history.location.pathname, customParam);

    useLayoutEffect(() => {
        // リフレッシュ対応
        // let state = store.getState().login;
        // let apiKey = null;
        // if (Object.keys(state).length !== 0) {
        //     apiKey = state.apiKey;
        // }
        // if (apiKey === null) {
        //     store.dispatch({ type: "CLEAR_STATE" });
        //     history.push("/reserve/login");
        // }
        // if (apiKey) {
        //     common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        // }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        // common.doPost(versionGetApi, {}, afterVerCheck);
        
        if (restaurantInfo?.changeFlg) {
            setChangeFlg(true);
            setLinkList([{ path: "/reserve/top", label: "HOME" }, { path: "/reserve/hotel/importedBookingConfirmDetail", label: "予約内容確認" }]);
        } else {
            setChangeFlg(false);
            setLinkList([{ path: "/reserve/top", label: "HOME" }, { path: "/reserve/hotel/restaurantReserveAll", label: "レストラン予約" }]);
        }
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
        if (Object.keys(restaurantInfo).length == 0 && Object.keys(restaurantReserveInfo).length == 0) {
            setIllegalFlg(true);
        } else {

            // 会員との関係一覧取得
            common.doPost(getMemberRelationList, {}, afterGetMemberRelationList);

            // 検索日を設定
            let playDate;
            let y = "";
            let m = "";
            let d = "";
            if (restaurantReserveInfo.riyoDate) {
                playDate = new Date(restaurantReserveInfo.riyoDate);
                d = playDate.getDate();
                y = playDate.getFullYear();
                m = playDate.getMonth() + 1;
                if (m < 10) m = `0${m}`
                if (d < 10) d = `0${d}`
            } else {
                playDate = "";
            }
            // 利用代表者情報設定
            let daihyouName = "";
            let daihyouNameKana = "";
            let mainPhoneNumber = "";
            let contactPhoneNumber = "";
            let contactMailAddress = "";
            if (loginUserInfo || Object.keys(restaurantReserveInfo).length) {
                daihyouNameKana = !restaurantReserveInfo.daihyouNameKana ? loginUserInfo.memberSeiKana + " " + loginUserInfo.memberMeiKana : restaurantReserveInfo.daihyouNameKana;
                daihyouName = !restaurantReserveInfo.daihyouName ? loginUserInfo.memberSei + " " + loginUserInfo.memberMei : restaurantReserveInfo.daihyouName;
                mainPhoneNumber = !restaurantReserveInfo.mainPhoneNumber ? (loginUserInfo.mobilePhone ? loginUserInfo.mobilePhone : loginUserInfo.phone) : restaurantReserveInfo.mainPhoneNumber;
                contactPhoneNumber = !restaurantReserveInfo.contactPhoneNumber ? (loginUserInfo.mobilePhone ? loginUserInfo.mobilePhone : loginUserInfo.phone) : restaurantReserveInfo.contactPhoneNumber;
                contactMailAddress = !restaurantReserveInfo.contactMailAddress ? loginUserInfo.pcAddress : restaurantReserveInfo.contactMailAddress;
            }
            setRestaurantReserveInfo({
                ...restaurantReserveInfo,
                daihyouNameKana: daihyouNameKana,
                daihyouName: daihyouName,
                mainPhoneNumber: mainPhoneNumber,
                contactPhoneNumber: contactPhoneNumber,
                contactMailAddress: contactMailAddress,
                riyoDate: playDate ? y + "-" + m + "-" + d : ""
            })

            let req = {
                honkanShisetsuCd: restaurantInfo.honkanShisetsuCd,
                shisetsuCd: restaurantInfo.shisetsuCd,
                cornerBunKbn: "1", /* 固定値 */
                restaurantCd: restaurantInfo.restaurantCd
            }
            if (restaurantReserveInfo?.agreementList) {
                setAgreementList(restaurantReserveInfo.agreementList)
            } else {
                common.doPost(getAgreeInfo, req, (res) => {
                    let data = res.data;
                    if (data.resultCode == 0) {
                        if (data.doiList && data.doiList.length != 0) {
                            let doiList = [];
                            data.doiList.forEach(doiInfo => {
                                doiList.push({
                                    title: doiInfo.doiTitle,
                                    text: doiInfo.doiSetsumei,
                                    link: doiInfo.doiSetsumeiURL,
                                    checked: restaurantInfo?.changeFlg ? true : false
                                });
                            })
                            setAgreementList(doiList);
                        }
                    }
                });
            }
        }


    }, [useMediaFlag]);

    // 会員との関係一覧取得後処理
    const afterGetMemberRelationList = (res) => {
        let data = res.data;
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
            setRelationList(commonUtil.getSelectList(data.relationList, "relationCd", "relationName", true, "選択する"));
        } else {
            // 一時エラー表示
            errorMessage = data.errorMessage;
            errorFlg = true;
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg })
    }

    // サービスチェック取得処理
    const requestGetServiceCheck = (relation) => {
        if (!relation) {
            // お部屋タイプ、続柄が未選択時はAPIを呼び出さない
            return;
        }
        // サービスチェック取得
        const req = {
            keiyakuNo: restaurantInfo.keiyakuNo,
            shisetsuCd: restaurantInfo.shisetsuCd,
            riyoDate: restaurantReserveInfo.riyoDate,
            hakuCnt: 0,
            tsuzukigaraCd: relation,
            riyoKaiinkenSyubetCd: restaurantInfo.riyoKaiinkenSyubetCd,
            roomTypeList: []
        }
        common.doPost(getServiceCheck, req, afterGetServiceCheck);
    }

    // サービスチェック取得後処理
    const afterGetServiceCheck = (res) => {
        let data = res.data;
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
            setServiceCheckInfo({
                kozafurikaeKanoKbn: data.kozafurikaeKanoKbn,
                kozafurikaeKiyakuMongon: data.kozaMongon,
            });
        } else {
            // 一時エラー表示
            errorMessage = data.errorMessage;
            errorFlg = true;
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg })
    }

    // アレルギー有無変更
    const onChangeAllergyInfo = () => {
        let allergyExistenceList = document.getElementsByName("allergyExistence");
        let allergyExistence = "";
        allergyExistenceList.forEach(value => {
            if (value.checked) {
                allergyExistence = value.value;
            }
        })
        setRestaurantReserveInfo({ ...restaurantReserveInfo, allergyExistence, allergyBiko: "" })
    }

    // 宿泊有無変更
    const onChangeReserveFlg = () => {
        let reserveFlgList = document.getElementsByName("reserveFlg");
        let reserveFlg = "";
        let newRestaurantReserveInfo = { ...restaurantReserveInfo}
        reserveFlgList.forEach(value => {
            if (value.checked) {
                reserveFlg = value.value;
            }
        })
        newRestaurantReserveInfo.reserveFlg = reserveFlg;
        if (reserveFlg == "0") { 
            newRestaurantReserveInfo.reserveNo = "";
        }
        setRestaurantReserveInfo(newRestaurantReserveInfo)
    }

    // 入力内容変更
    const handleRepresentInfo = (id) => {
        let input = document.getElementById(id).value;
        let newRestaurantReserveInfo = {...restaurantReserveInfo};
        newRestaurantReserveInfo[id] = input;
        setRestaurantReserveInfo(newRestaurantReserveInfo);
    }

    // 同意チェック変更
    const onChangeAgreement  = (doiIndex) => {
        let agreement = document.getElementById("agreement" + doiIndex).checked;
        let newAgreementList = [];
        agreementList.forEach((value) => {
            newAgreementList.push(value);
        });
        newAgreementList[doiIndex].checked = agreement;
        setAgreementList(newAgreementList);
    }

    // 入力内容変更(チェックボックス)
    const onChangeCheckBox = (name) => {
        let changeEle = document.getElementsByName(name);
        let changeValue = changeEle[0].checked;
        let newRestaurantReserveInfo = {...restaurantReserveInfo};
        if (name == "otherMailFlg") {
            let confirmReserveEle = document.getElementsByName("kakuninMailKiboKbn");
            if (confirmReserveEle[0].checked) {
                newRestaurantReserveInfo[name] = changeValue;
            }
            if (!changeValue) {
                newRestaurantReserveInfo.confirmReserveMail = "";
            }
        } else {
            newRestaurantReserveInfo[name] = changeValue;
        }
        if (name == "kakuninMailKiboKbn" && !changeValue) {
            newRestaurantReserveInfo.confirmReserveMail = "";
            newRestaurantReserveInfo.otherMailFlg = false;
        }
        setRestaurantReserveInfo(newRestaurantReserveInfo);
    }

    // 会員様との関係変更
    const onChangeRelation = () => {
        let relation = document.getElementById("relation").value;
        if (relation) {
            setRestaurantReserveInfo({ ...restaurantReserveInfo, relationCd: relation })
            requestGetServiceCheck(relation);
        } else {
            setRestaurantReserveInfo({ ...restaurantReserveInfo, relationCd: relation, kozafurikaeFlg: false })
        }
    }

    // 時間帯変更
    const onChangeJikantai = () => {
        let jikantaiEle = document.getElementsByName("jikantaiRadio");
        jikantaiEle.forEach(jikantai => {
            if (jikantai.checked) {
                setRestaurantReserveInfo({ ...restaurantReserveInfo, jikantai: jikantai.value })
            } 
        })
    }

    // 同意情報表示
    const onClickDoiTitle = (doiIndex) => {
        let doiInfo = agreementList[doiIndex]
        setPopupData({
            doiInfo: doiInfo,
        });
        onClickOpenPopupWindow("doiInfo");
    }

    // サービス情報表示
    const onClickServiceLink = (serviceTitle, serviceText) => {
        setPopupData({
            serviceInfo: {
                serviceTitle: serviceTitle,
                serviceText: serviceText
            }
        });
        onClickOpenPopupWindow("serviceInfo");
    }

    // 「戻る」ボタン押下時
    const onClickBack = () => {
        if (restaurantInfo?.changeFlg) {
            history.push("/reserve/hotel/importedBookingConfirmDetail");
        } else {
            history.push("/reserve/hotel/restaurantReserveAll");
        }
    }

    // const getValuesById = (ids) => {
    //     const ret = [];
    //     for (const id of ids) {
    //         ret[id] = document.getElementById(id).value;
    //     }
    //     return ret;
    // }

    const getRadioValue = (name) => {
        let items = document.getElementsByName(name);
        let ret = "";
        items.forEach(value => {
            if (value.checked) {
                ret = value.value;
            }
        })
        return ret;
    }

    // 利用日カレンダーモーダル
    const onClickOpenCalendar = (startDate) => {
        let reqRestaurantInfo = store.getState().restaurantInfo;
        let reqReserveInfo = {...store.getState().restaurantReserveInfo};
        reqReserveInfo.riyoDate = startDate;
        // カレンダー空き情報取得
        onClickOpenCalendarWindow(reqRestaurantInfo, reqReserveInfo);
    }

    // 予約登録チェック後処理
    const afterSetReserve = (res) => {
        let data = res.data;
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
            history.push("/reserve/hotel/restaurantConfirmUser");
        } else {
            errorMessage = data.errorMessage;
            errorFlg = true;
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg })
    }

    // 「確認画面へ」ボタン押下時
    const onClickCheckInput = () => {

        const allergyExistence = getRadioValue("allergyExistence");
        const allergyBiko = document.getElementById("allergyBiko").value;
        const foodRequest = document.getElementById("foodRequest").value;
        const daihyouNameKana = document.getElementById("daihyouNameKana").value;
        const daihyouName = document.getElementById("daihyouName").value;
        const mainPhoneKbn = getRadioValue("mainPhoneKbn");
        const mainPhoneNumber = document.getElementById("mainPhoneNumber").value;
        const contactPhoneNumber = document.getElementById("contactPhoneNumber").value;
        const contactMailAddress = document.getElementById("contactMailAddress").value;
        const relation = document.getElementById("relation") ? document.getElementById("relation").value : "";
        const kozafurikaeFlgEle = document.getElementsByName("kozafurikaeFlg");
        const kozafurikaeFlg = kozafurikaeFlgEle.length != 0 ? kozafurikaeFlgEle[0].checked : false;
        const kakuninMailKiboKbn = document.getElementById("kakuninMailKiboKbn").checked;
        let confirmReserveMail = document.getElementById("confirmReserveMail")?.value;
        const otherMailFlgEle = document.getElementsByName("otherMailFlg");
        const otherMailFlg = otherMailFlgEle.length != 0 ? otherMailFlgEle[0].checked : "";
        const reserveFlg = false;
        const reserveNo = "";

        const flgList = {
            jikantai: false,
            riyoDate: false,
            peopleNum: false,
            yoyakuTime: false,
            courseList: false,
            allergyExistence: false,
            allergyBiko: false,
            foodRequest: false,
            daihyouNameKana: false,
            daihyouName: false,
            mainPhoneKbn: false,
            mainPhoneNumber: false,
            reserverTelType: false,
            contactPhoneNumber: false,
            contactMailAddress: false,
            remarks: false,
            kakuninMailKiboKbn: false,
            confirmReserveMail: false,
            reserveFlg: false,
            reserveNo: false,
            doi: [],
            validFlg: false,
            requireFlg: false
        };



        let errorMessages = [];
        // バリデーションチェック

        agreementList.forEach(doiInfo => {
            if (doiInfo.checked) {
                flgList.doi.push(false);
            } else {
                flgList.requireFlg = true;
                flgList.doi.push(true);
            }
        })
        if (CommonValidation.Require(restaurantReserveInfo.jikantai)) {
            flgList.requireFlg = true;
            flgList.jikantai = true;
        }
        if (CommonValidation.Require(restaurantReserveInfo.riyoDate)) {
            flgList.requireFlg = true;
            flgList.riyoDate = true;
        }
        if (CommonValidation.Require(restaurantReserveInfo.peopleNum)) {
            flgList.requireFlg = true;
            flgList.peopleNum = true;
        }
        if (CommonValidation.Require(restaurantReserveInfo.yoyakuTime)) {
            flgList.requireFlg = true;
            flgList.yoyakuTime = true;
        }
        if (!restaurantReserveInfo.courseList || restaurantReserveInfo.courseList.length === 0) {
            flgList.requireFlg = true;
            flgList.courseList = true;
        } else {
            let totalNum = 0;
            restaurantReserveInfo.courseList.forEach(course => {
                totalNum += course.courseNum;
            })
            if (totalNum > restaurantReserveInfo.peopleNum || (restaurantReserveInfo.peopleNum - restaurantReserveInfo.babyCnt - restaurantReserveInfo.preschoolerCnt) > totalNum) {
                flgList.validFlg = true;
                flgList.peopleNum = true;
                flgList.courseList = true;
            }
        }
        if (CommonValidation.Require(allergyExistence)) {
            flgList.requireFlg = true;
            flgList.allergyExistence = true;
        }
        if (allergyExistence === "1") {
            if (CommonValidation.Require(allergyBiko)) {
                flgList.requireFlg = true;
                flgList.allergyBiko = true;
            } else if (CommonValidation.OverMaxLengthCareHalfHull(allergyBiko, 667)) {
                flgList.validFlg = true;
                flgList.allergyBiko = true;
            }
        }
        if (!CommonValidation.Require(foodRequest) && CommonValidation.OverMaxLengthCareHalfHull(foodRequest, 667)) {
            flgList.validFlg = true;
            flgList.foodRequest = true;
        }
        if (CommonValidation.Require(daihyouNameKana)) {
            flgList.requireFlg = true;
            flgList.daihyouNameKana = true;
        } else if (CommonValidation.NameKanaSLC(daihyouNameKana) || CommonValidation.OverMaxLength(daihyouNameKana, 36)) {
            flgList.validFlg = true;
            flgList.daihyouNameKana = true;
        }
        if (CommonValidation.Require(daihyouName)) {
            flgList.requireFlg = true;
            flgList.daihyouName = true;
        } else if (CommonValidation.ZenkakuAndSpace(daihyouName) || CommonValidation.OverMaxLength(daihyouName, 36)) {
            flgList.validFlg = true;
            flgList.daihyouName = true;
        }
        if (CommonValidation.Require(mainPhoneKbn)) {
            flgList.requireFlg = true;
            flgList.mainPhoneKbn = true;
        }
        if (CommonValidation.Require(mainPhoneNumber)) {
            flgList.requireFlg = true;
            flgList.mainPhoneNumber = true;
        } else if (CommonValidation.Hankaku(mainPhoneNumber) || CommonValidation.OverMaxLength(mainPhoneNumber, 16)) {
            flgList.validFlg = true;
            flgList.mainPhoneNumber = true;
        }
        if (CommonValidation.Require(contactPhoneNumber)) {
            flgList.requireFlg = true;
            flgList.contactPhoneNumber = true;
        } else if (CommonValidation.Hankaku(contactPhoneNumber) || CommonValidation.OverMaxLength(contactPhoneNumber, 16)) {
            flgList.validFlg = true;
            flgList.contactPhoneNumber = true;
        }
        if (CommonValidation.Require(contactMailAddress)) {
            flgList.requireFlg = true;
            flgList.contactMailAddress = true;
        } else if (CommonValidation.NotMail(contactMailAddress) || CommonValidation.OverMaxLength(contactMailAddress, 51)) {
            flgList.validFlg = true;
            flgList.contactMailAddress = true;
        }
        if (CommonValidation.Require(relation)) {
            flgList.requireFlg = true;
            flgList.relation = true;
        }
        if (kakuninMailKiboKbn) {
            if (restaurantInfo.changeFlg || otherMailFlg) {
                if (CommonValidation.Require(confirmReserveMail)) {
                    flgList.requireFlg = true;
                    flgList.confirmReserveMail = true;
                } else if (CommonValidation.NotMail(confirmReserveMail) || CommonValidation.OverMaxLength(confirmReserveMail, 51)) {
                    flgList.validFlg = true;
                    flgList.confirmReserveMail = true;
                }
            } else {
                confirmReserveMail = contactMailAddress;
            }
        }
        if (flgList.requireFlg) {
            errorMessages.push(MessageConst.REQUIRE_INPUT_ERROR);
        }
        if (flgList.validFlg) {
            errorMessages.push(MessageConst.VALID_INPUT_ERROR);
        }
        if (errorMessages.length > 0) {
            window.scroll({ top: 0, behavior: 'smooth' })
            setErrorInfo({ errorMessage: errorMessages, errorFlg: true });
            setFlgList(flgList);
        } else {
            let gairaiList = [{
                riyoDate: restaurantReserveInfo.riyoDate,
                jikantaiKbn: restaurantReserveInfo.jikantai,
                rstEstheCd: restaurantInfo.restaurantCd,
                cornerBunKbn: "1",
                startTime: restaurantReserveInfo.yoyakuTime,
                adultCnt: restaurantReserveInfo.adultCnt,
                childCnt: restaurantReserveInfo.childCnt,
                preschoolerCnt: restaurantReserveInfo.preschoolerCnt,
                babyCnt: restaurantReserveInfo.babyCnt,
                gairaiCnt: restaurantReserveInfo.peopleNum
            }];
    
            let gairaiCourseList = [];
            restaurantReserveInfo.courseList.forEach(value => {
                gairaiCourseList.push({
                    riyoDate: restaurantReserveInfo.riyoDate,
                    jikantaiKbn: restaurantReserveInfo.jikantai,
                    rstEstheCd: restaurantInfo.restaurantCd,
                    gairaiCourseCd: value.courseCd,
                    targetCnt: value.courseNum
                });
            });

            setRestaurantReserveInfo({...restaurantReserveInfo,
                agreementList,
                allergyExistence,
                allergyBiko,
                foodRequest,
                daihyouNameKana,
                daihyouName,
                mainPhoneKbn,
                mainPhoneNumber,
                contactPhoneNumber,
                contactMailAddress,
                relation: relationList.find(value => value.id == relation).value,
                relationCd: relation,
                kozafurikaeDispFlg: kozafurikaeFlgEle.length != 0,
                kozafurikaeFlg: kozafurikaeFlg,
                kakuninMailKiboKbn: kakuninMailKiboKbn,
                confirmReserveMail,
                reserveFlg,
                reserveNo,
                gairaiList,
                gairaiCourseList,
                gairaiRsvKbn: "1"
            });
            
    
            let req = {
                shisetsuCd: restaurantInfo.shisetsuCd,
                keiyakuNo: restaurantInfo.keiyakuNo,
                pointKaiinId: restaurantInfo.memberCd,
                registFlg: false,
                riyoKaiinkenSyubetCd: restaurantInfo.riyoKaiinkenSyubetCd,
                riyoDate: restaurantReserveInfo.riyoDate,
                hakuCnt: 0,
                foodRequest: foodRequest,
                allergyKbn: allergyExistence,
                allergyBiko: allergyBiko,
                daihyouNameKana: daihyouNameKana,
                daihyouName: daihyouName,
                mainPhoneKbn: mainPhoneKbn,
                mainPhoneNumber: mainPhoneNumber,
                contactPhoneNumber: contactPhoneNumber,
                contactMailAddress: contactMailAddress,
                relationCd: relation,
                kozafurikaeFlg: kozafurikaeFlg,
                kakuninMailKiboKbn: kakuninMailKiboKbn ? "1" : "0",
                kakuninMailAddress: confirmReserveMail,
                reserveFlg: reserveFlg,
                reserveNo: reserveNo,
                gairaiList: gairaiList,
                gairaiCourseList: gairaiCourseList,
                hakuCnt: 0,
                carCnt:0,
                importedFlg: true, /* 外来フラグ　固定値 */
                userInfo: userInfoReq,
                changeFlg: restaurantInfo.changeFlg,
                yoyakuNo: restaurantReserveInfo.yoyakuNo ? restaurantReserveInfo.yoyakuNo : "",
                gairaiRsvKbn: "1"
            };
            setErrorInfo({ errorMessage: [], errorFlg: false });
            if (restaurantInfo.changeFlg) {
                common.doPost(changeReserve, req, afterSetReserve);
            } else {
                common.doPost(setReserve, req, afterSetReserve);
            }
        }
    }

    return (
        <div className="userInputInnerWrapper">
            <BreadCrumb
                breadCrumbStyle={isWideTablet ? { display: "none" } : styles.breadCrumb}
                linkStyle={styles.link}
                linkList={linkList}
                lastLabel={restaurantInfo?.changeFlg ? "お客様情報入力(人数・時間変更)" : "お客様情報入力"}
                lastLabelClassName="lastLabel"
            />
            <div style={isWideTablet ? styles.breadCrumb2 : { display: "none" }}></div>
            {illegalFlg ?
                <div className="reserveInputWrapper">
                    <Label
                        label={MessageConst.ILLEGAL_ACCESS_ERROR}
                        style={styles.illegalDiv}
                    />
                </div>
                :
                <>
                     <div className="reserveInputWrapper">
                        <div className={"reserveInfo"} style={styles.userInput}>
                            <div style={errorInfo.errorFlg ? styles.errorDiv : { display: "none" }}>
                                <ErrorMassage style={styles.errorMassage} data={errorInfo.errorMessage} />
                            </div>
                            <Label
                                label={"ご予約内容"}
                                className="titleLabel"
                            />
                            <div className={"reserveInfoContentBlock"}>
                                <div className="reservationContent lastContent">
                                    <Label
                                        label="レストラン名"
                                        className="reserveInfoTitleGray"
                                    />
                                    <Label
                                        label={restaurantInfo.shisetsuName + "\n" + restaurantInfo.restaurantName}
                                        className="reserveInfoContentLabel"
                                    />
                                </div>
                            </div>
                        </div>
                        {/* レストラン入力フォーム */}
                        <RestaurantInputList
                            restaurantInfo={restaurantInfo}
                            restaurantReserveInfo={restaurantReserveInfo}
                            setRestaurantReserveInfo={setRestaurantReserveInfo}
                            agreementList={agreementList}
                            relationList={relationList}
                            serviceCheckInfo={serviceCheckInfo}
                            onChangeAgreement={onChangeAgreement}
                            onChangeCheckBox={onChangeCheckBox}
                            onChangeReserveFlg={onChangeReserveFlg}
                            onChangeAllergyInfo={onChangeAllergyInfo}
                            onChangeRelation={onChangeRelation}
                            onChangeJikantai={onChangeJikantai}
                            onClickDoiTitle={onClickDoiTitle}
                            onClickServiceLink={onClickServiceLink}
                            handleRepresentInfo={handleRepresentInfo}
                            mealTypeList={[]}
                            titleClassName="titleLabel"
                            flgList={flgList}
                            vacancyItems={vacancyItems}
                            responsiveFlg={isWideTablet}
                            changeFlg={restaurantInfo?.changeFlg}
                            onClickOpenPopupWindow={onClickOpenPopupWindow}
                            onClickOpenCalendarWindow={onClickOpenCalendar}
                            setPopupData={setPopupData}
                        />
                    </div>
                    <div className="btnToConfirmWrapper">
                        <div className="confirmboxWrap">
                            <Button buttonText="戻る" className="btnBack btnSpStyle" onClick={onClickBack} buttonClassName="serachBtnText" />
                            <Button buttonText="確認画面へ" className="btnToConfirm btnSpStyle2" onClick={onClickCheckInput} buttonClassName="serachBtnText" />
                        </div>
                    </div>
                </>
            }
            <div className="backTopInput">
                <Link to={"/reserve/hotel/restaurantReserveAll"} style={styles.bottomLink}>レストラン予約TOPへ戻る</Link>
                <div style={temporaryErrorInfo.errorFlg ? styles.errorDiv : { display: "none" }}>
                    <ErrorMassage style={styles.errorMassage} data={[temporaryErrorInfo.errorMessage]} />
                </div>
            </div>
            <div style={styles.footer}>
                <MembershipFooterContainer className={"reservationResultFooterBase"} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        login: state.login,
        restaurantInfo: state.restaurantInfo,
        restaurantReserveInfo: state.restaurantReserveInfo,
        serviceCheckInfo: state.serviceCheckInfo,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setRestaurantReserveInfo: (item) => {
            dispatch({ type: "RESTAURANT_RESERVE_INFO", payload: { restaurantReserveInfo: item } })
        },
        setServiceCheckInfo: (item) => {
            dispatch({ type: "SERVICE_CHECK_INFO", payload: { serviceCheckInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(RestaurantInputUserContainer);

const styles = {
    breadCrumb: {
        display: "flex",
        color: "white",
        padding: "8px 0px 30px 0px",
    },
    breadCrumb2: {
        marginBottom: "30px",
    },
    userInput: {
        display: "block",
        flexWrap: "wrap",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    bottomLink: {
        padding: "3px",
        color: "#696969",
        fontSize: "small",
    },
    errorMassage: {
        display: "inline-block",
        textAlign: "left",
        padding: "15px 0px 0px 0px",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
    illegalDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
}